<template>
  <b-container v-if="auth == 'loggedin' || token != null || token != undefined">
    <b-card
      class="text-center mt-2"
      header="Egyéb tételek szerkesztése"
      border-variant="primary"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <b-card-body class="text-left">
        <div class="col-sm-">
          <div class="row-fluid">
            <!-- // FORM -->
            <b-form @submit="addElement">
              <div class="form-group">
                <label for="megnevezes">Megnevezés</label>
                <b-form-input
                  size="sm"
                  type="text"
                  v-model="list.megnevezes"
                  class="form-control"
                  id="megnevezes"
                  required
                />
              </div>

              <div class="form-group">
                <label for="mennyisegiegyseg">Mennyiségi egység</label>
                <b-form-input
                  size="sm"
                  type="text"
                  v-model="list.mennyisegiegyseg"
                  class="form-control"
                  id="mennyisegiegyseg"
                  required
                />
              </div>

              <div class="form-group">
                <label for="netto">Nettó</label>
                <b-form-input
                  size="sm"
                  type="number"
                  v-model="list.netto"
                  class="form-control"
                  id="netto"
                  required
                />
              </div>

              <!-- // SAVE -->
              <b-button variant="primary" type="submit">
                <b-icon-cloud-upload></b-icon-cloud-upload>
                Mentés
              </b-button>

              <!-- // CANCEL -->
              <b-button
                variant="outline-danger"
                class="float-right"
                @click="
                  $router.push({
                    name: 'Cikkek'
                  })
                "
                ><b-icon-arrow-left></b-icon-arrow-left>
                Mégsem</b-button
              >
            </b-form>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </b-container>
</template>

<script>
import axios from 'axios'
import router from '../router'
import jwtDecode from 'jwt-decode'

export default {
  data: () => {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      token: localStorage.usertoken,
      auth: '',
      userType : decoded.usertype,
      list: {}
    }
  },
  methods: {
    addElement: function () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.id = this.list.id
        payload.megnevezes = this.list.megnevezes
        payload.mennyisegiegyseg = this.list.mennyisegiegyseg
        payload.netto = this.list.netto
        payload.hidden = 1
        payload.token = this.token
        payload.userType = this.userType
        axios
          .post('https://'+process.env.ROOT_API+'/cikkek/save', { payload })
          .then(res => {
            this.$router.push({ name: 'Cikkek' })
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  },
  mounted: function () {
    let id = this.$route.params.id
    let payload = {}
    if (!this.token) {
      router.push({ name: 'Login' })
    } else {
      payload.id = id
      payload.token = this.token
      payload.userType = this.userType
      if (id) {
        axios
          .post('https://'+process.env.ROOT_API+'/cikkek/edit', { payload })
          .then(res => {
            this.list = res.data
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CikkekNew.vue